import VueRouter from 'vue-router'
//pages
import Index from "./views/app/pages/Index";
import Login from './views/app/pages/auth/Login'
import Reset from './views/app/pages/auth/reset'
import ResetPassword from './views/app/pages/auth/reset-password'
import changePassword from './views/app/pages/auth/change-password'
import Register from './views/app/pages/auth/register'
import Basket from "./views/app/pages/Basket";
import Order from "./views/app/pages/Order";
import ProductPage from "./views/app/pages/ProductPage";
import ProductWayPage from "./views/app/pages/ProductWayPage"
import ManagerPage from "./views/app/pages/ManagerPage";
import History from "./views/app/pages/history/HistoryList";
import HistorySingle from "./views/app/pages/history/History";
import GetApi from "./views/app/pages/GetApi";


import Admin from "./views/app/admin/Index";
import AdminMenu from "./views/app/admin/Menu";
import AdminHistory from "./views/app/admin/histories/Index";
import AdminHistoryInsert from "./views/app/admin/histories/insert";

import AdminMailings from "./views/app/admin/mailings/index";
import AdminMailingsMessage from './views/app/admin/mailings/message';

import AdminTechIssues from "./views/app/admin/tech/index"

import AdminBanner from "./views/app/admin/Banner/Index";
import AdminBannerInsert from "./views/app/admin/Banner/insert";

import AdminSubscribe from "./views/app/admin/subscribe/Index";

import AdminManagers from "./views/app/admin/managers/Index";
import AdminManagerInsert from "./views/app/admin/managers/register";
import AdminManagerEdit from "./views/app/admin/managers/edit";

import Settings from './views/app/admin/Settings';
import SettingsManager from './views/app/manager/SettingsManager';

import AdminUsers from "./views/app/admin/users/Index";
import AdminUsersInsert from "./views/app/admin/users/register";
import AdminUserEdit from "./views/app/admin/users/edit";
import historyUser from "./views/app/admin/users/history";

import Manager from "./views/app/manager/Index";
import ManagerMenu from "./views/app/manager/Menu";
import ManagerUsers from "./views/app/manager/users/Index";
import ManagerUsersEdit from "./views/app/manager/users/insert";

import ManagerHistoryAll from './views/app/manager/histories/AllUsers';
import ManagerHistoryInsert from "./views/app/manager/histories/insert";
import auth from "@websanova/vue-auth/demos/nuxt/middleware/auth";


import ProductsOnWay from './views/app/admin/way/index';
import ProductsOnWayAdd from './views/app/admin/way/edit';
import ProductsOnWayEdit from './views/app/admin/way/edit';

export default new VueRouter({
    routes: [
        {
            path: '',
            component: Index,
            auth: false,
            children: [
                // {
                //     path: '',
                // },
                {
                    path: '/change-password/:id?',
                    name: 'changePassword',
                    component: changePassword,
                },
                {
                    path: '/basket',
                    name: 'Basket',
                    component: Basket,
                    meta: {
                        auth: {roles: ['user','user.wholesale'], redirect: {name: 'login'}}
                    }
                },
                {
                    path: '/order',
                    name: 'Order',
                    component: Order,
                    meta: {
                        auth: {roles: ['user','user.wholesale'], redirect: {name: 'login'}}
                    }
                },
                {
                    path: '/product/:alias',
                    name: 'ProductPage',
                    component: ProductPage,
                    meta: {
                        auth: {roles: ['admin', 'manager', 'user', 'user.wholesale'], redirect: {name: 'login'}}
                    }
                },

                {
                    path: '/way-product/:alias',
                    name: 'ProductWayPage',
                    component: ProductWayPage,
                    meta: {
                        auth: {roles: ['admin', 'manager', 'user', 'user.wholesale'], redirect: {name: 'login'}}
                    }
                },

                {
                    path: '/manager',
                    name: 'ManagerPage',
                    component: ManagerPage,
                    meta: {
                        auth: {roles: ['user','user.wholesale'], redirect: {name: 'login'}}
                    }
                },

                {
                    path: '/history',
                    name: 'History',
                    component: History,
                    meta: {
                        auth: {roles: ['user','user.wholesale'], redirect: {name: 'login'}}
                    },
                },

                {
                    path: '/history/:order_number',
                    name: 'HistorySingle',
                    component: HistorySingle,
                    meta: {
                        auth: {roles: ['user','user.wholesale'], redirect: {name: 'login'}}
                    },
                },

                {
                    path: '/get-api',
                    name: 'GetApi',
                    component: GetApi,
                    meta: {
                        auth: {roles: ['user','user.wholesale'], redirect: {name: 'login'}}
                    }
                },

                {
                    path: 'admin',
                    component: Admin,

                    meta: {
                        auth: {roles: 'admin', redirect: {name: 'login'}}
                    },

                    children: [

                        {
                            path: '',
                            name: 'AdminMenu',
                            redirect: 'histories',
                            component: AdminMenu,
                        },

                        {
                            path: 'orders',
                            name: 'Order',
                            component: Order,
                        },

                        {
                            path: 'subscribe',
                            name: 'AdminSubscribe',
                            component: AdminSubscribe,
                        },

                        {
                            path: 'mailings',
                            name: 'AdminMailings',
                            component: AdminMailings,
                        },

                        {
                            path: 'mailings/message',
                            name: 'AdminMailingsMessage',
                            component: AdminMailingsMessage,
                        },

                        {
                            path: 'users',
                            name: 'AdminUsers',
                            component: AdminUsers,
                            props: true
                        },

                        {
                            path: 'users/edit/:id',
                            name: 'AdminUserEdit',
                            component: AdminUserEdit,
                        },

                        {
                            path: 'users/history/:id',
                            name: 'historyUser',
                            component: historyUser,
                        },

                        {
                            path: 'users/add',
                            name: 'AdminUsersInsert',
                            component: AdminUsersInsert,
                        },

                        {
                            path: 'histories',
                            name: 'AdminHistory',
                            component: AdminHistory,
                        },

                        {
                            path: 'histories/edit/:order_number',
                            name: 'AdminHistoryInsert',
                            component: AdminHistoryInsert,
                        },


                        {
                            path: 'stocks',
                            name: 'AdminBanner',
                            component: AdminBanner,
                            props: true
                        },

                        {
                            path: 'stocks/add',
                            name: 'AdminBannerInsert',
                            component: AdminBannerInsert,
                        },

                        {
                            path: 'stocks/edit/:id',
                            name: 'AdminBannerInsert',
                            component: AdminBannerInsert,
                        },

                        {
                            path: 'managers',
                            name: 'AdminManagers',
                            component: AdminManagers,
                            props: true
                        },

                        {
                            path: 'managers/add',
                            name: 'AdminManagerInsert',
                            component: AdminManagerInsert,
                        },

                        {
                            path: 'managers/edit/:id',
                            name: 'AdminManagerEdit',
                            component: AdminManagerEdit,
                        },

                        {
                            path: 'tech-issues',
                            name: 'AdminTechIssues',
                            component: AdminTechIssues,
                        },

                        {
                            path: 'way',
                            name: 'ProductsOnWay',
                            component: ProductsOnWay,
                        },

                        {
                            path: 'settings',
                            name: 'Settings',
                            component: Settings,
                        },

                        {
                            path: 'way/add',
                            name: 'ProductsOnWayAdd',
                            component: ProductsOnWayAdd
                        },

                        {
                            path: 'way/edit/:id',
                            name: 'ProductsOnWayEdit',
                            component: ProductsOnWayEdit
                        }
                    ]
                },

                {
                    path: 'managers',
                    component: Manager,

                    meta: {
                        auth: {roles: 'manager', redirect: {name: 'login'}}
                    },

                    children: [

                        {
                            path: '',
                            name: 'ManagerMenu',
                            redirect: 'users',
                            component: ManagerMenu,
                        },

                        {
                            path: 'settings',
                            name: 'SettingsManager',
                            component: SettingsManager,
                        },

                        {
                            path: 'users',
                            name: 'ManagerUsers',
                            component: ManagerUsers,
                            props: true
                        },

                        {
                            path: 'orders',
                            name: 'Order',
                            component: Order,
                        },

                        {
                            path: 'users/edit/:id',
                            name: 'ManagerUsersEdit',
                            component: ManagerUsersEdit,
                        },


                        {
                            path: 'histories',
                            name: 'ManagerHistoryAll',
                            component: ManagerHistoryAll
                        },

                        {
                            path: 'histories/edit/:order_number',
                            name: 'ManagerHistoryInsert',
                            component: ManagerHistoryInsert,
                        },
                    ]
                },
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                auth: false
            }
        },
        {
            path: '/reset',
            name: 'reset',
            component: Reset,
            meta: {
                auth: false
            }
        },
        {
            path: '/reset-password/',
            name: 'PasswordReset',
            component: ResetPassword,
            meta: {
                auth: false
            }
        },
        {
            path: '/register',
            name: 'Register',
            component: Register,
            meta: {
                auth: false
            }
        },
    ],

    mode: 'history'
});



// WEBPACK FOOTER //
// ./src/router.js